import { UserRole } from '../types';

export const isCommercialProfile = (role?: string | UserRole | null): boolean => {
  if (!role) return false;
  const normalized = String(role).trim().toUpperCase();
  return (
    normalized === UserRole.COMERCIAL_INTERNO ||
    normalized === UserRole.ADMIN ||
    normalized === UserRole.SUPERADMIN
  );
};
